import { render } from "./warnRanking.vue?vue&type=template&id=175d040a&scoped=true"
import script from "./warnRanking.vue?vue&type=script&lang=js"
export * from "./warnRanking.vue?vue&type=script&lang=js"

import "./warnRanking.vue?vue&type=style&index=0&id=175d040a&lang=scss&scoped=scoped"
import "./warnRanking.vue?vue&type=style&index=1&id=175d040a&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175d040a"]])

export default __exports__